export default "__VITE_ASSET__DAujZ1M4__"